const ENTER_TRANSITION_DURATION_MS = 200;
const statusCls = "_275sggm39y";
const tHeadingTrCls = "_275t1vp71yh";
const content = "_275c1fwxngi";
const transitionCls = "_275t173jyfm";
const tHeadingCls = "_275t6d1mob";
const tHeadingChevronCls = "_275t1eysosh";
const tSortHeadingCls = "_275t1fxjk8c";
const tCellCls = "_275tgesk2h";
const tClampCls = "_275t74yhbg";
const tLinkCls = "_275te613jv";
const tDateCls = "_275tcljrdg";
const tTitleCls = "_275tw07a01";
const tUrlCls = "_275tehayzv";

export { ENTER_TRANSITION_DURATION_MS, content, statusCls, tCellCls, tClampCls, tDateCls, tHeadingChevronCls, tHeadingCls, tHeadingTrCls, tLinkCls, tSortHeadingCls, tTitleCls, tUrlCls, transitionCls };
import "./page.style.linaria.module.css";
//# sourceMappingURL=page.style.js.map
